var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable, reaction } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
export var FacilitatedFHIRAuthState;
(function (FacilitatedFHIRAuthState) {
    FacilitatedFHIRAuthState["INACTIVE"] = "INACTIVE";
    FacilitatedFHIRAuthState["IN_PROGRESS"] = "IN_PROGRESS";
    FacilitatedFHIRAuthState["SUCCESS"] = "SUCCESS";
    FacilitatedFHIRAuthState["ERROR"] = "ERROR";
})(FacilitatedFHIRAuthState || (FacilitatedFHIRAuthState = {}));
export var FacilitatedFHIRAuthErrorReason;
(function (FacilitatedFHIRAuthErrorReason) {
    FacilitatedFHIRAuthErrorReason["AUTH_WINDOW_CLOSED"] = "AUTH_WINDOW_CLOSED";
    FacilitatedFHIRAuthErrorReason["AUTH_FAILED"] = "AUTH_FAILED";
    FacilitatedFHIRAuthErrorReason["WRONG_STATE"] = "WRONG_STATE";
    FacilitatedFHIRAuthErrorReason["NO_AUTH_DATA"] = "NO_AUTH_DATA";
})(FacilitatedFHIRAuthErrorReason || (FacilitatedFHIRAuthErrorReason = {}));
export class FacilitatedFHIRAuthManager {
    constructor(persistence, routingUIManager) {
        this.persistence = persistence;
        this.routingUIManager = routingUIManager;
        this.state = { state: FacilitatedFHIRAuthState.INACTIVE };
        reaction(() => this.routingUIManager.currentRoute, (currentRoute) => {
            if ((currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.routeName) === NamedRoutes.FACILITATED_FHIR_CALLBACK.routeName) {
                void this.processFacilitatedFHIRAuthCallback();
            }
            else if (currentRoute !== null) {
                this.resetAuthStateIfNeeded();
            }
        }, { fireImmediately: true, name: "FacilitatedFHIRAuthManager_currentRoute" });
        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                this.resetAuthStateIfNeeded();
            }
        });
    }
    get hasCompletedAuth() {
        return this.state.state === FacilitatedFHIRAuthState.SUCCESS || this.state.state === FacilitatedFHIRAuthState.ERROR;
    }
    async redirectToFacilitatedFHIRLoginPage(key, url, state, callbackHash) {
        this.state = { state: FacilitatedFHIRAuthState.IN_PROGRESS, key };
        this.setFacilitatedFHIRAuthData({
            key,
            state,
            callbackHash,
        });
        window.location.href = url;
    }
    async processFacilitatedFHIRAuthCallback() {
        const data = new URLSearchParams(window.location.search);
        const code = data.get("code");
        const state = data.get("state");
        const error = data.get("error");
        const authData = this.getFacilitatedFHIRAuthData();
        if (!authData) {
            this.onError(FacilitatedFHIRAuthErrorReason.NO_AUTH_DATA);
            return;
        }
        if (error) {
            this.onError(FacilitatedFHIRAuthErrorReason.AUTH_FAILED, authData === null || authData === void 0 ? void 0 : authData.key);
        }
        else if (code) {
            if (authData.state !== state) {
                this.onError(FacilitatedFHIRAuthErrorReason.WRONG_STATE, authData === null || authData === void 0 ? void 0 : authData.key);
                return;
            }
            this.onSuccess(authData.key, code);
        }
        else {
            this.onError(FacilitatedFHIRAuthErrorReason.AUTH_FAILED, authData === null || authData === void 0 ? void 0 : authData.key);
        }
        window.history.replaceState(null, "", window.location.href.replace(window.location.search, ""));
    }
    getRedirectUri() {
        let origin = window.location.origin;
        if (origin.includes("app.demo.healthex.dev"))
            origin = "https://app.healthex.dev";
        return `${origin}/#/epic-nexus/redirect`;
    }
    resetAuth() {
        this.state = { state: FacilitatedFHIRAuthState.INACTIVE };
    }
    handleAuthError(error, key) {
        this.onError(error, key);
    }
    onError(error, key) {
        this.state = { state: FacilitatedFHIRAuthState.ERROR, key: key !== null && key !== void 0 ? key : "", error };
    }
    onSuccess(key, code) {
        this.state = { state: FacilitatedFHIRAuthState.SUCCESS, key, code };
    }
    getFacilitatedFHIRAuthData() {
        return this.persistence.getFacilitatedFHIRAuthData();
    }
    setFacilitatedFHIRAuthData(authData) {
        this.persistence.setFacilitatedFHIRAuthData(authData);
    }
    resetAuthStateIfNeeded() {
        const authData = this.getFacilitatedFHIRAuthData();
        if (authData) {
            this.setFacilitatedFHIRAuthData(null);
            this.onError(FacilitatedFHIRAuthErrorReason.AUTH_FAILED, authData.key);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], FacilitatedFHIRAuthManager.prototype, "state", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], FacilitatedFHIRAuthManager.prototype, "hasCompletedAuth", null);
